// The #import-upload-status element is replaced by two independent sources at
// once: the live Turbo Stream broadcast pushed on every progress tick, and
// status_poller_controller's 2.5s HTTP fallback poll. Both target the same
// element with no ordering guarantee between them, so a poll response that
// was in flight while a newer tick already broadcast can land afterward and
// visibly snap the progress bar backward.
//
// Every state partial under app/views/import_template_uploads (validating,
// writing, completed, ...) stamps its root element with data-phase (which
// partial this is, given the same "processing" status covers more than one)
// and, where relevant, data-progress. A replacement is stale — and skipped —
// only when it claims to be the same phase as what's already rendered but
// carries a lower progress value. Any phase change always wins outright,
// since real state transitions are driven by the state machine and aren't
// firing rapidly enough to race each other the way progress ticks do.
document.addEventListener("turbo:before-stream-render", (event) => {
  const { newStream, render } = event.detail;
  if (newStream.target !== "import-upload-status") return;

  event.detail.render = async (streamElement) => {
    if (isStaleProgressUpdate(streamElement)) return;
    await render(streamElement);
  };
});

function isStaleProgressUpdate(streamElement) {
  const current = document.getElementById("import-upload-status");
  if (!current) return false;

  const incoming = streamElement.templateContent.getElementById("import-upload-status");
  if (!incoming) return false;

  const currentPhase = current.dataset.phase;
  const incomingPhase = incoming.dataset.phase;
  if (!currentPhase || currentPhase !== incomingPhase) return false;

  const currentProgress = current.dataset.progress;
  const incomingProgress = incoming.dataset.progress;
  if (currentProgress === undefined || incomingProgress === undefined) return false;

  // A numeric progress already on screen beats a blank incoming value
  // outright — the only way to see "no progress yet" after "42%" in the same
  // phase is a poll response dispatched before the first tick landing late.
  if (currentProgress !== "" && incomingProgress === "") return true;
  if (currentProgress === "" || incomingProgress === "") return false;

  return Number(incomingProgress) < Number(currentProgress);
}
